import {
	Msg,
	msg_batch_add,
	msg_clean,
	msg_clean_all,
	msg_del,
	msg_del_by_cid,
	msg_query,
	msg_search,
	MsgQryCond,
	Query,
	MsgSearchCond,
	qry_sending_msg,
	qry_all_msg_tid,
	RTCContent,
	Meta,
	msg_update_meta,
	msg_query_one,
	msg_update_thumbnailPath,
	msg_exists_any_mid,
} from '../db/t_msg';
import Context from './context';
import time from '../time';
import { CryptEngine } from '../../src/utils/CryptEngine';
import { topic_del, topic_del_all } from '../db/t_topic';
import { MessageType } from '../../src/constants/types';
import { RTCEngine } from '../../src/utils/RTCEngine';

// sdk消息状态上报请求
type MsgStat = {
	mid: string; // 全局消息id
	uid: number; // 全局uid
	sender: number; // 消息的发送者，这个是为了方便后台做处理加入的
	time: number; // 记录产生的时间戳，客户端生成（时间同步的重要性）
	Type: string; // 取值：read-已读 receipt-收到
};

export default class MsgController {
	// 查询消息
	public static async QryByCond(ctx: Context, cond: MsgQryCond): Promise<{ error: any; msgs?: Msg[] }> {
		return await msg_query(ctx.db, cond);
	}

	public static async Query(ctx: Context, search: string, time: number, tids?: string[]) {
		return await Query(ctx.db, search, time, tids);
	}

	// 查询消息
	public static async QryBySearch(ctx: Context, cond: MsgSearchCond): Promise<{ error: any; msgs?: Msg[] }> {
		return await msg_search(ctx.db, cond);
	}

	public static async QrySendingMsg(ctx: Context, tid: string, cid: number, sender: number): Promise<{ error: any; msgs?: Msg[] }> {
		return await qry_sending_msg(ctx.db, tid, cid, sender);
	}

	public static async QryAllMsgTids(ctx: Context): Promise<{ code: any; tids?: { tid: string; mid: string }[] }> {
		return await qry_all_msg_tid(ctx.db);
	}

	public static async CleanAllMsg(ctx: Context, body: any): Promise<{ code: any }> {
		await ctx.conn.Call('/v1/sdk/msg/delete/batch', body);
		const r = await topic_del_all(ctx.db);
		if (r.rowsAffected > 0) {
			ctx.mq.emit('topic_refresh', {});
		}
		return await msg_clean_all(ctx.db);
	}

	public static async CleanById(ctx: Context, tid: string, mid?: string): Promise<{ code: any }> {
		if (mid && mid.length > 0) {
			await ctx.conn.Call('/v1/sdk/msg/delete', {
				tid: tid,
				mid: mid,
			});
		}
		return await msg_clean(ctx.db, tid);
	}

	public static async UpsetMsg(ctx: Context, uid: number, msg: Msg): Promise<{ error: any }> {
		const batchid = time.toUnixMillSecond(time.now()); // 批次id
		return await msg_batch_add(ctx.db, uid, batchid, [msg]);
	}

	public static async DelMsgByCid(ctx: Context, tid: string, cid: number, mid: string, sender: number): Promise<{ code: any }> {
		return await msg_del_by_cid(ctx.db, tid, cid, sender, mid);
	}
	public static async DelMsg(ctx: Context, tid: string, msgs: { mid: string; cid: number }[]): Promise<{ code: any }> {
		return await msg_del(ctx.db, tid, msgs);
	}

	// 查询最近消息,直接从服务器拉取
	public static async QryLatest(ctx: Context, tid: string): Promise<{ error: any; msgs?: Msg[]; overlap?: boolean; oldestMid?: string }> {
		const body = { tid: tid, size: 50, containMax: true };
		return await this.QryMsgRemote(ctx, tid, body);
	}

	// 更新消息meta内容
	public static async updateMsgMeta(ctx: Context, mid: string, meta: any): Promise<{ error?: any }> {
		const r = await msg_update_meta(ctx.db, mid, meta);
		return { error: r.error };
	}

	// 更新消息meta内容
	public static async updateThumbnailPath(ctx: Context, mid: string, thumbnailPath: string): Promise<{ error?: any }> {
		return msg_update_thumbnailPath(ctx.db, mid, thumbnailPath);
	}

	// 查询消息meta内容
	public static async queryMsg(ctx: Context, mid: string): Promise<{ error?: any }> {
		return msg_query_one(ctx.db, mid);
	}

	// 查询最近消息,直接从服务器拉取
	public static async QryMsgRemote(ctx: Context, tid: string, body: any): Promise<{ error: any; msgs?: Msg[]; overlap?: boolean; oldestMid?: string }> {
		const r1 = await ctx.conn.Call('/v1/sdk/msg/history', body);
		if (!(r1 && r1.code === 0)) {
			return { error: r1 };
		}

		if (r1.data && r1.data.msgs) {
			const batchid = time.toUnixMillSecond(time.now());
			const msgs = r1.data.msgs as Msg[];
			const mids = msgs.map((m) => m.mid).filter((m) => !!m);
			const overlapRst = await msg_exists_any_mid(ctx.db, tid, mids);
			const overlap = overlapRst.exists === true;
			const oldestMid = msgs.length > 0 ? (msgs[msgs.length - 1].mid || "") : "";
			{
				// 这行代码太重要了 查了一天 泪
				const n = msgs.length;
				for (let i = 0; i < n; i++) {
					const msg = msgs[i];
					msg.content = CryptEngine.decode(msg.encrypt, msg.content, msg.cid);
					msg.tid = tid;

					if ((msg.type === MessageType.RTC_VOICE || msg.type === MessageType.RTC_VIDEO) && msg.rtcId) {
						let meta: Meta = {};
						if (msg.visible === -2) {
							meta.rtcId = msg.rtcId?.toString();
							meta.duration = msg.duration || 0;
						} else {
							const rtc: any = await RTCEngine.rtcQuery(msg.rtcId.toString());
							if (rtc && rtc.data && rtc.data.rtc && rtc.data.rtc.rtcId) {
								meta.rtcId = rtc.data.rtc.rtcId?.toString();
								meta.duration = msg.duration || 0;
								meta.status = rtc.data.rtc.status;
								meta.memberList = rtc.data.rtc.memberList;
								msg.rtcId = undefined;
							} else {
								meta.rtcId = msg.rtcId?.toString();
								meta.duration = msg.duration || 0;
							}
						}
						msg.meta = meta;
					}
				}
			}
			// log.debug('写入消息', msgs);
			const err = await msg_batch_add(ctx.db, ctx.uid, batchid, msgs);
			return { error: err.error || overlapRst.error, msgs: msgs, overlap, oldestMid };
		}
		return { error: null };
	}

	public static retryMsgRead: { mid: string; sender: number }[] = []; // 小于0表示没处理
	public static msgReadTaskMap: Map<string, number> = new Map<string, number>(); // 小于0表示没处理

	public static Clear() {
		MsgController.retryMsgRead = [];
		MsgController.msgReadTaskMap = new Map<string, number>();
	}

	// 消息已读上报
	public static async Read(ctx: Context, mids: { mid: string; sender: number }[]): Promise<{ error: any; reportMids?: string[] }> {
		let unReaportMids: { mid: string; sender: number }[] = [];
		mids.forEach((v) => {
			if (!MsgController.msgReadTaskMap.has(v.mid)) {
				MsgController.msgReadTaskMap.set(v.mid, time.toUnixMillSecond(time.now()));
				unReaportMids.push(v);
			}
		});

		if (MsgController.retryMsgRead.length > 0) {
			unReaportMids.push(...MsgController.retryMsgRead);
			MsgController.retryMsgRead = [];
		}

		if (unReaportMids.length <= 0) {
			return { error: null };
		}
		const msgStats: MsgStat[] = [];
		const t = time.toUnixMillSecond(time.now());
		unReaportMids.forEach((v) => {
			msgStats.push({
				uid: ctx.uid,
				mid: v.mid,
				sender: v.sender,
				time: t,
				Type: 'read',
			});
		});
		const r = await ctx.conn.Call('/v1/report/status', { msgStats: msgStats });
		if (r && r.code === 0) {
			return { error: null, reportMids: unReaportMids.map((v) => v.mid) };
		}

		MsgController.retryMsgRead.push(...unReaportMids);

		// todo 检查map是否太长了
		if (MsgController.msgReadTaskMap.size >= 1500) {
			// 删除最早的数据
		}
		return { error: r };
	}

	// 消息 0-正常 1-删除 2-撤回
	public async Mask(
		ctx: Context,
		mid: string, // 消息Id
		mask: number // 0-正常 1-删除 2-撤回
	): Promise<{ error: any }> {
		const r = await ctx.conn.Call('/v1/sdk/msg/mask', { mid: mid, mask: mask });
		if (r && r.code === 0) {
			return { error: null };
		}
		return { error: r };
	}

	// 消息审核
	public async Audit(
		ctx: Context,
		mid: string, // 消息Id
		result: string // pass - 允许 refused - 拒绝
	): Promise<{ error: any }> {
		const r = await ctx.conn.Call('/v1/sdk/msg/audit', {
			mid: mid,
			result: result,
		});
		if (r && r.code === 0) {
			return { error: null };
		}
		return { error: r };
	}
}
